import { render, staticRenderFns } from "./AdditionalAbandonedCartReminder.vue?vue&type=template&id=fdb2923e&scoped=true&"
import script from "./AdditionalAbandonedCartReminder.vue?vue&type=script&lang=js&"
export * from "./AdditionalAbandonedCartReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb2923e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdb2923e')) {
      api.createRecord('fdb2923e', component.options)
    } else {
      api.reload('fdb2923e', component.options)
    }
    module.hot.accept("./AdditionalAbandonedCartReminder.vue?vue&type=template&id=fdb2923e&scoped=true&", function () {
      api.rerender('fdb2923e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/AdditionalAbandonedCartReminder.vue"
export default component.exports